/* eslint-disable no-unused-expressions */
import React, { useCallback, useState } from 'react';
import { TableGral, RowTable, ColTable, theme } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { canRefund, moneyFormat, getInstallments } from 'helpers';
import { isAllowed } from 'helpers/auth';
import { Menu } from 'components/Menu';
import { MenuItem } from '@material-ui/core';
import { getStatus, getMethod } from 'constants/transactions';
import RefundModal from 'components/Modal/RefundModal';
import { useConfig, useRefund, useTransaction } from 'hooks';
import { formatDate } from 'helpers/date';
import { getEnv } from 'config';

export const TextoFpay = styled.div`
  text-align: center;
  font-size: 12px;
  letter-spacing: 0;
  color: ${theme.colors.gray800};
  opacity: 1;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 180px;
  padding: 12px;
`;

const ContainerMount = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 600;
  text-align: right;
  display: flex;
  align-items: center;
`;

const MountColor = styled.span`
  color: ${(props) => (props.plus ? '#3b9326' : '#333333')};
`;

const TransactionTableOnus = ({ dataTable }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { getRefundDetail, getDetail } = useTransaction();
  const { getRefunds } = useRefund();
  const { country } = getEnv();

  const { config } = useConfig();

  const handleToggleModal = () => setShowModal((prevShowModal) => !prevShowModal);
  const handleGetRefundDetail = (transaction) => {
    handleToggleModal();
    getRefundDetail(transaction);
  };

  const handleDetail = useCallback((data) => {
    getRefunds(data.sale_authorization_id, data.event_date);
    getDetail(data);
  }, []);

  const maxDaysToRefund = config?.transactions?.refund_limit_days?.on_us;

  const transactionCanRefundKey = isAllowed('REFUND');
  const showRefundKey = isAllowed('TRANSACTIONS_REFUND_DETAIL');

  return (
    <>
      <TableGral>
        <RowTable header>
          <ColTable header>{t('transactionsFalabella.operationType')}</ColTable>
          <ColTable header>{t('transactionsFalabella.authCode')}</ColTable>
          <ColTable header>{t('transactionsFalabella.payMethod')}</ColTable>
          <ColTable header>{t('transactionsFalabella.quotes')}</ColTable>
          <ColTable header>{t('transactionsFalabella.dateHour')}</ColTable>
          <ColTable header align="center" justify="flex-end">
            <span style={{ paddingRight: '24px' }}>
              {t('transactionsFalabella.mountGrossValue')}
            </span>
          </ColTable>
        </RowTable>
        {dataTable?.map((item, index) => (
          <RowTable key={index + item.authorization_id}>
            <ColTable datajs={t('transactionsFalabella.operationType')} heightColMobile="36px">
              {getStatus(item.type)}
            </ColTable>
            <ColTable datajs={t('transactionsFalabella.authCode')} heightColMobile="36px">
              {item.authorization_id}
            </ColTable>
            <ColTable datajs={t('transactionsFalabella.payMethod')} heightColMobile="36px">
              {getMethod(item.operation)}
            </ColTable>
            <ColTable datajs={t('transactionsFalabella.quotes')} heightColMobile="36px">
              {getInstallments(item.installment, item.number_of_installments)}
            </ColTable>
            <ColTable datajs={t('transactionsFalabella.dateHour')} heightColMobile="36px">
              {formatDate(item?.event_date, 'DD-MM-YYYY | HH:mm', false, 'UTC', country) || '-'}
            </ColTable>
            <ColTable
              align="right"
              datajs={t('transactionsFalabella.mountGrossValue')}
              justify="flex-end"
              order={-1}
              mobileTitle
              heightColMobile="36px"
            >
              <ContainerMount>
                {item.gross_value && item.gross_value >= 0 ? (
                  <>
                    <MountColor plus>+{moneyFormat(item.gross_value)}</MountColor>
                  </>
                ) : (
                  <>
                    <MountColor>{moneyFormat(item.gross_value)}</MountColor>
                  </>
                )}
                <div
                  style={{
                    width: '24px',
                    paddingTop: '4px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingLeft: '6px',
                  }}
                >
                  <Menu
                    icon="ic_menu_dots.svg"
                    imageStyle={{ width: '18px', height: '18px' }}
                    style={{ float: 'right' }}
                    id="menu"
                    htmlId="transactions-submenu"
                  >
                    {canRefund(item.operation, item.event_date, maxDaysToRefund) &&
                      transactionCanRefundKey && (
                        <MenuItem
                          id="transactions-return-money"
                          onClick={() => {
                            handleDetail(item);
                          }}
                        >
                          Devolver dinero
                        </MenuItem>
                      )}
                    { (getStatus(item.type) === 'Devolución') &&
                      showRefundKey && (
                        <MenuItem
                          id="transactions-return-money"
                          onClick={() => handleGetRefundDetail(item)}
                        >
                          Detalle
                        </MenuItem>
                      )}
                  </Menu>
                </div>
              </ContainerMount>
            </ColTable>
          </RowTable>
        ))}
      </TableGral>
      {showModal && <RefundModal fClose={handleToggleModal} />}
    </>
  );
};

export default TransactionTableOnus;
